import React from 'react'
import ChecklistRow from './ChecklistRow'

export interface IW9Form {
  id: number
  fullName: string
  parentUserId: string
}

export interface IW9FormProps {
  w9Form: IW9Form
}

export const W9Form: React.FunctionComponent<IW9FormProps> = React.memo(({ w9Form }) => {
  const { fullName, parentUserId } = w9Form || {}
  return <ChecklistRow sectionName='W9 Form' id={parentUserId} fullName={fullName} />
})
